// ==============================|| OVERRIDES - PICKERS CALENDAR HEADER ||============================== //

export default function PickersCalendarHeader(theme) {
	return {
		MuiPickersCalendarHeader: {
			styleOverrides: {}
		}
	}
}
